import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import AddAttribute from "@pages/Contents/Corporate/Attributes/AddAttribute";
import Attributes from "@pages/Contents/Corporate/Attributes";
import EditAttribute from "@pages/Contents/Corporate/Attributes/EditAttribute";

const useCorporateAttributes = () => {
  const { isInclude } = useIsInclude();

  return [
    {
      path: "attributes",
      children: [
        {
          index: true,
          path: "",
          element: (
            <ProtectedRoute
              isAllowed={isInclude("corporate&&fe.enrollment.attributes.read")}
            >
              <Attributes />
            </ProtectedRoute>
          ),
        },
        {
          path: "add",
          element: (
            <ProtectedRoute
              isAllowed={isInclude("corporate&&enrollment.attributes.write")}
            >
              <AddAttribute />
            </ProtectedRoute>
          ),
        },
        {
          path: "edit/:idAttribute",
          element: (
            <ProtectedRoute
              isAllowed={isInclude("corporate&&enrollment.attributes.write")}
            >
              <EditAttribute />
            </ProtectedRoute>
          ),
        },
      ],
    },
  ];
};

export default useCorporateAttributes;
